import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiShield, FiZap, FiBarChart2, FiSmartphone } from 'react-icons/fi';

const Benefits = () => {
  const list = [
    {
      title: 'Precision Accuracy',
      desc: 'Calculations based on gender, age, weight, and activity for 99% accuracy.',
      icon: FiZap,
      color: 'bg-yellow-500'
    },
    {
      title: 'Total Privacy',
      desc: 'Your data never leaves your device. No servers, no tracking, just results.',
      icon: FiShield,
      color: 'bg-green-500'
    },
    {
      title: 'Advanced Macros',
      desc: 'Get specific protein, carb, and fat targets for every fitness goal.',
      icon: FiBarChart2,
      color: 'bg-blue-500'
    },
    {
      title: 'Expert Export',
      desc: 'Save your metabolic blueprint as a high-res JPG for your coach or logs.',
      icon: FiSmartphone,
      color: 'bg-purple-500'
    }
  ];

  return (
    <section className="py-20 border-t border-gray-100 dark:border-gray-800">
      <h2 className="text-3xl font-black mb-12 text-center uppercase tracking-tighter">Why Use TDEE Lab?</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {list.map((item, i) => (
          <div key={i} className="p-6 rounded-3xl bg-gray-50 dark:bg-gray-800/30 border border-transparent hover:border-blue-500/30 transition-all group">
            <div className={`w-12 h-12 ${item.color} rounded-2xl flex items-center justify-center text-white mb-6 shadow-lg group-hover:scale-110 transition-transform`}>
              <SafeIcon icon={item.icon} className="w-6 h-6" />
            </div>
            <h3 className="text-lg font-bold mb-2">{item.title}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Benefits;